import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-microphone-troubleshoot-dialog',
  templateUrl: './microphone-troubleshoot-dialog.component.html',
  styleUrl: './microphone-troubleshoot-dialog.component.scss',
  standalone: false,
})
export class MicrophoneTroubleshootDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<MicrophoneTroubleshootDialogComponent>>(MatDialogRef);

  close() {
    this.dialogRef.close(true);
  }
}
